import { Slogan } from './Slogan';
import { Info } from './Info';
import { Events } from './Events';
import { Members } from './Members';

export const Index = () => (
    <>
        <Slogan />
        <Info />
        <Events />
        <Members />
    </>
);
